import { render, staticRenderFns } from "./VChart2.vue?vue&type=template&id=244f80c4&"
import script from "./VChart2.vue?vue&type=script&lang=js&"
export * from "./VChart2.vue?vue&type=script&lang=js&"
import style0 from "./VChart2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports